export const activeIndicator = theme => ({
  backgroundColor: theme.palette.secondary.dark,
  bottom: -1,
  height: 2,
  position: 'absolute',
  width: '100%',
});

export const border = theme => ({
  border: `1px solid ${theme.palette.graphic.light}`,
});

export const boxStyles = (theme, { singleChip }) => ({
  '& > span': {
    '& > div': {
      marginBottom: 0,
    },
    /* height in ch is the height relative to the lower case h, based on imported font */
    height: '1.82ch',
    margin: '0 0 0 1px',
    padding: 0,
  },
  '&:first-child': {
    marginRight: theme.spacing(0.5),
  },
  borderRadius: 0.5,
  cursor: singleChip ? 'initial' : 'pointer',
  display: 'inline-flex',
  height: 20,
  width: 30,
});

export const chipLabel = theme => ({
  ...theme.typography.caption,
  fontWeight: 400,
  /* height in ch is the height relative to the lower case h, based on imported font */
  height: '1.82ch',
  letterSpacing: 0.5,
  padding: 0,
});

export const dualCount = {
  display: 'inline-flex',
  marginBottom: 0,
};

export const iconRoot = theme => ({
  backgroundColor: theme.palette.primary.lighter,
  height: 20,
  minWidth: 20,
  padding: theme.spacing(0, 0.5),
});

export const tabsContainer = theme => ({
  borderBottom: `1px solid ${theme.palette.graphic.light}`,
  display: 'inline-flex',
  gridColumnGap: 24,
  margin: theme.spacing(0, 0, 3, 3),
  minHeight: 40,
  zIndex: 2,
});

export const tabsContainerMobile = theme => ({
  backgroundColor: theme.palette.surface.white,
  bottom: 0,
  boxShadow: theme.shadows[0],
  height: 56,
  left: 0,
  margin: 0,
  padding: theme.spacing(0, 3),
  position: 'fixed',
  right: 0,
  width: '100%',
  zIndex: 10,
});

export const tabsSingle = {
  borderBottom: 'none',
};
